<ng-container>
<app-header [navbarBrandRouterLink]="['/dashboard']" [asideMenuToggler]="false" [fixed]="true" [navbarBrandFull]="{src: 'assets/img/brand/poker_logo.png', width: 107, height: 25, alt: 'lobbyze Logo'}" (click)="WindowResize($event)" [navbarBrandMinimized]="{src: 'assets/img/brand/logo2.png', width: 30, height: 30, alt: 'lobbyze Logo'}" [sidebarToggler]="'lg'" [mobileAsideMenuToggler]="false">
  <ul class="nav navbar-nav d-md-down-none" *ngIf="!isShopPage()">
    <!-- <li class="nav-item px-3">
      <a class="nav-link" [routerLink]="['/dashboard']">Dashboard</a>
    </li> -->
    <li class="nav-item px-3">
      <a class="nav-link" [routerLink]="['/tournaments']">{{ 'tournaments' | translate }}</a>
    </li>
    <li class="nav-item px-3">
      <a class="nav-link" [routerLink]="['/scheduled-tournaments']">{{ 'manage_schedules' | translate }}</a>
    </li>
  </ul>
  
  <div class="row m-0 ml-auto align-items-center justify-content-center">
    <div class="col-auto p-0 d-none d-md-block" *ngIf="!isShopPage()">
      <div class="row m-0 align-items-center">
        <div class="col-auto p-0 px-1">
          <div>
            <div class="dropdown" dropdown placement="bottom">
              <div class="tour-button" tooltip="{{'help' | translate}}" triggers="hover" dropdownToggle>
                <span class="d-none d-lg-inline-block">{{ 'need_help' | translate }}</span><i class="fa fa-question-circle ml-2"></i>
              </div>
              <div class="dropdown-menu dropdown-menu-right dropdown-menu-guide" *dropdownMenu>
                <ng-container>
                  <a class="dropdown-item" style="cursor: pointer;" (click)="openStarterWizard($event)"><i class="fa fa-magic mr-2"></i>{{ 'starter_wizard_menu' | translate }}</a>
                  <a class="dropdown-item" style="cursor: pointer;" (click)="openHelpChat($event)"><i class="fa fa-comment mr-2"></i>{{ 'need_help' | translate }}</a>
                  <a class="dropdown-item" style="cursor: pointer;" (click)="openExternal($event, 'https://www.youtube.com/watch?v=9SIYvxW6acw')" target="_blank"><i class="fa fa-youtube-play mr-2"></i>Tutorial Completo [PT-BR]</a>
                  <a class="dropdown-item" style="cursor: pointer;" (click)="openExternal($event, 'https://www.youtube.com/watch?v=zOoy0PGp4qQ')" target="_blank"><i class="fa fa-youtube-play mr-2"></i>Complete Tutorial [ENG]</a>
                  <a class="dropdown-item" style="cursor: pointer; padding-left: 13px !important;" (click)="openExternal($event, 'https://discord.gg/TuyP475sgd')" target="_blank">
                    <img
                      class="discord-icon"
                      src="/assets/icons/discord.png"
                    />
                    Discord
                  </a>
                  <a class="dropdown-item" style="cursor: pointer" href="mailto:support@lobbyze.com" target="_blank"><i class="fa fa-envelope"></i>Email</a>
                  <a class="dropdown-item" *ngIf="!bloquedFunctions" style="cursor: pointer" (click)="executeNonMasterGuide()"><i class="fa fa-book"></i>{{ 'start_guide' | translate }}</a>
                  <a class="dropdown-item" *ngIf="!bloquedFunctions" style="cursor: pointer" (click)="executeRebalanceGuide()"><i class="fa fa-book"></i>{{ 'rebalance_guide' | translate }}</a>
                  <a class="dropdown-item" *ngIf="!bloquedFunctions" style="cursor: pointer" (click)="executeManageFiltersGuide()"><i class="fa fa-book"></i>{{ 'manage_filters_guide' | translate }}</a>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto" *ngIf="bloquedFunctions">
      <button class="btn btn-success" (click)="openSubscription()"><i class="fa fa-shopping-cart mr-2"></i>{{ 'get_a_license' | translate }}</button>
    </div>
    <div class="col-auto pl-2 pr-0 d-none d-lg-block">
      {{ 'current_tier' | translate }}:
    </div>
    <div class="col-auto p-0" [ngClass]="{'border-right': showTitleBar}">
      <div class="row m-0 align-items-center">
        <div class="col-auto p-0 px-1">
          <div class="dropdown tier-dropdown mr-2" dropdown placement="bottom">
            <div class="tier-name" dropdownToggle>
              <span class="pl-1">{{ team }}</span>
              <i class="fa fa-angle-down" tooltip="{{ 'open_tier_list' | translate }}" container="body" triggers="hover" placement="bottom"></i>
            </div>
            <div class="dropdown-menu dropdown-menu-right tier-list overflow-x-hidden" style="width: 350px;" *dropdownMenu>
              <div class="row m-0">
                <div class="col-6 p-0">
                  <ng-container *ngIf="allowNewTier$ | withLoading | async as allowNewTier">
                    <a
                      *ngIf="allowNewTier.value; else notAllow"
                      class="dropdown-item clickable"
                      (click)="addNewTierModal.show()"
                    >
                      {{ 'add_new_tier' | translate }} <i class="ml-1 fa fa-plus"></i>
                    </a>
                    <ng-template #notAllow>
                      <a class="dropdown-item"
                        tooltip="{{ 'tiers_must_have_4_users' | translate }}"
                        triggers="hover"
                        placement="bottom"
                      >
                        {{ 'add_new_tier' | translate }}<i class="ml-1 fa fa-ban"></i>
                      </a>
                    </ng-template>
                  </ng-container>
                </div>
                <div class="col-6 p-0">
                  <div class="input-group mt-1 pr-1">
                    <div class="input-group-prepend">
                      <span class="input-group-text"><i class="fa fa-search"></i></span>
                    </div>
                    <input class="form-control" [(ngModel)]="tierSearch" (click)="$event.stopPropagation()" type="text">
                  </div>
                </div>
              </div>
              <ng-container *ngIf="tierList$ | withLoading | async as wait">
                <ng-container *ngIf="wait.value as tierList">
                  <ng-container *ngFor="let tier of tierList.tiers; index as i">
                    <div class="row flex-nowrap m-0" *ngIf="searchCheck(tier.name)" [style.borderBottom]="tier.member_count != null && i < (tierList.tiers.length - 1) ? '1px solid #caeaf5' : 'unset'">
                      <div class="p-0 min-w-0 flex-fill">
                        <a class="dropdown-item tier-item text-wrap clickable" [class]="tier.member_count != null ? 'owner' : ''" (click)="selectTier(tier)"><i class="fa fa-book"></i>{{ tier.name }}{{ tier.member_count != null ? ' - ' + tier.member_count + ' users' : '' }}</a>
                      </div>
                      <div class="col-1 p-0">
                        <button class="btn-default-tier" container="body" tooltip="{{ 'set_default_tier' | translate }}" [class]="tier.member_count != null ? 'owner' : ''" (click)="$event.stopPropagation(); setDefaultTier(tier)"><i class="fa fa-check" [ngStyle]="{'color': defaultTier == tier.id ? 'green' : null}"></i></button>
                      </div>
                      <div class="col-1 p-0" *ngIf="tier.is_owner">
                        <button class="btn-delete-tier" [class]="tier.member_count != null ? 'owner' : ''" [disabled]="tierList.ownedTiersCount <= 1" [tooltip]="tierList.ownedTiersCount <= 1 ? ('cannot_delete_last_tier' | translate) : ''" container="body" triggers="hover" (click)="tierToDelete = tier; modalDelete.show()"><i class="fa fa-trash"></i></button>
                      </div>
                      <div class="col-1 p-0" *ngIf="!tier.is_owner" tooltip="{{ 'leave_tier' | translate }}">
                        <button class="btn-leave-tier" (click)="tierToDelete = tier; modalLeave.show()"><i class="icon-logout icons"></i></button>
                      </div>
                    </div>
                  </ng-container>
                  <div class="row m-0 free-available-row" *ngIf="tierList.freeAvailable" (click)="joinFreeTiers()">
                    <div class="p-0 flex-fill">
                      <a
                        container="body"
                        tooltip="{{ 'free_tier_tooltip' | translate }}"
                      >
                          <i class="fa fa-star"></i>
                          {{ 'free_tier_available' | translate }} (Reg Life)
                        </a>
                    </div>
                  </div>
                </ng-container>
                <span class="dropdown-item disabled" *ngIf="wait.loading"><i class="fa fa-arrow-circle-o-down"></i>{{ 'loading' | translate }}...</span>
                <span class="dropdown-item disabled" *ngIf="wait.error"><i class="fa fa-exclamation"></i>Error</span>
              </ng-container>
            </div>
          </div>
        </div>
        <div *ngIf="!bloquedFunctions" class="col-auto p-0 px-1">
          <div class="notification-bell-area">
            <i (click)="notificationBellOpen = !notificationBellOpen" class="fa" [class]="notificationBellContent.count > 0 ? 'fa-bell' : 'fa-bell-o'"></i>
            <span (click)="notificationBellOpen = !notificationBellOpen" class="bell-number" *ngIf="notificationBellContent.count > 0">{{ notificationBellContent.count < 10 ? notificationBellContent.count : '+9' }}</span>
            <div *ngIf="notificationBellOpen" class="notification-bell-content card">
              <div class="card-body p-0">
                <div class="notification-bell-item" *ngFor="let item of notificationBellContent.items">
                  <a href="/approve-tournaments"><i class="fa fa-inbox mr-2"></i>{{ item }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-auto p-0 px-1">
          <li class="nav-item dropdown" dropdown placement="bottom right" style="list-style: none;">
            <a class="nav-link px-1" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle (click)="false">
              <img src="assets/img/avatars/profile.png" class="img-avatar" alt="user profile" />
              <img width="0" height="0" src="assets/img/brand/logo_rectangulo.png" />
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-user-menu" *dropdownMenu aria-labelledby="simple-dropdown">
              <a class="dropdown-item user-info-item" href="#">
                <img src="assets/img/avatars/profile.png" width="20px" class="img-avatar" alt="user profile" />
                <span class="user-name">{{ userName }}</span>
                <div>
                  <small style="opacity: 0.7;">{{ userEmail }}</small>
                </div>
              </a>
              <ng-container *ngIf="tierLicense$ | withLoading | async as wait">
                <div class="dropdown-item" *ngIf="wait.value as tierLicense">
                  {{ 'available_slots' | translate }} {{ tierLicense.used_slots }}/{{ tierLicense.available_slots }} [{{licenseType}}]
                </div>
                <div class="dropdown-item disabled" *ngIf="wait.loading"><i class="fa fa-arrow-circle-o-down"></i>{{ 'loading' | translate }}...</div>
              </ng-container>
              <ng-container *ngIf="mySubText$ | withLoading | async as wait">
                <div class="dropdown-item" *ngIf="wait.value as value">
                  {{ 'subscription' | translate }}: {{ value }}
                </div>
                <div class="dropdown-item disabled" *ngIf="wait.loading"><i class="fa fa-arrow-circle-o-down"></i>{{ 'loading' | translate }}...</div>
              </ng-container>
              <div class="dropdown-header"><strong>Settings</strong></div>
              <a class="dropdown-item" [href]="identityUrl + '/forgot-password'"><img class="custom-icon" src="/assets/icons/custom/password_icon.svg" />{{ 'manage_password' | translate }}</a>
              <a class="dropdown-item" (click)="openSubscription()" style="cursor: pointer"><img class="custom-icon contrast" src="/assets/icons/custom/money_icon.svg" />{{ 'manage_subscription' | translate }}</a>
              <a class="dropdown-item" *ngIf="showTitleBar" (click)="openNotificationOptionsModal()" style="cursor: pointer"><i class="fa fa-bell"></i>{{ 'notification_options' | translate }}</a>
              <a class="dropdown-item" *ngIf="isNativeMode()" (click)="openPreferencesModal()" style="cursor: pointer"><i class="fa fa-cog"></i>{{ 'window_behavior' | translate }}</a>
              <div class="divider"></div>
              <div class="dropdown-header"><strong>{{ 'preferences' | translate }}</strong></div>
              <div (click)="$event.stopPropagation();">
                <div class="row m-0 border-bottom justify-content-between">
                  <div class="col-6 border-right py-3 text-center">
                    <div class="language-picker-area" tooltip="{{'change_language' | translate}}" triggers="hover">
                      <div class="dropdown" dropdown placement="bottom">
                        <div class="language-picker" dropdownToggle>
                          <span [class]="getCurrentLang() == 'en-US' ? 'flag-icon-us' : getCurrentLang() == 'pt-BR' ? 'flag-icon-br' : getCurrentLang() == 'es' ? 'flag-icon-es' : 'flag-icon-ru'" class="flag-icon"></span>
                        </div>
                        <div class="dropdown-menu menu-flags dropdown-menu-right" *dropdownMenu>
                          <ng-container>
                            <a class="item-flag clickable" (click)="selectLanguage('en-US')"><i class="flag-icon flag-icon-us flag-icon-squared flag-icon-item"></i></a>
                            <a class="item-flag clickable" (click)="selectLanguage('pt-BR')"><i class="flag-icon flag-icon-br flag-icon-squared flag-icon-item"></i></a>
                            <a class="item-flag clickable" (click)="selectLanguage('es')"><i class="flag-icon flag-icon-es flag-icon-squared flag-icon-item"></i></a>
                            <a class="item-flag clickable" (click)="selectLanguage('ru')"><i class="flag-icon flag-icon-ru flag-icon-squared flag-icon-item"></i></a>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 py-3 px-1 text-center">
                    <div style="cursor: pointer;" (click)="toggleUITheme()" tooltip="{{'switch_theme' | translate}}" triggers="hover">
                      <span style="margin-right: 13px;"><img src="/assets/icons/custom/sun_icon.svg" style="height: 20px; margin-top: -5px;" /></span>
                      <label class="switch">
                        <div class="switchCheck" [ngClass]="{'checked-dark': isDarkTheme}">
                          <span class="slider round"></span>
                        </div>
                      </label>
                      <span style="margin-left: 5px;"><img src="/assets/icons/custom/moon_icon.svg" style="height: 13px; margin-top: -5px;" /></span>
                    </div>
                  </div>
                </div>
                <div class="row m-0 justify-content-between border-bottom">
                  <div class="col-12 pt-2 pb-1 text-center">
                    <div class="row align-items-center justify-content-center m-0">
                      <div class="col-4 px-4 row-button" (click)="changeTableZoom(-0.1)" tooltip="{{'decrease_table_zoom' | translate}}" triggers="hover">
                        <i class="fa fa-search-minus"></i>
                      </div>
                      <div class="col-4 px-4">
                        <i class="fa fa-list row-icon"></i>
                      </div>
                      <div class="col-4 px-4 row-button" (click)="changeTableZoom(0.1)" tooltip="{{'increase_table_zoom' | translate}}" triggers="hover">
                        <i class="fa fa-search-plus"></i>
                      </div>
                    </div>
                    <div class="row align-items-center justify-content-center m-0">
                      <div class="col-auto px-4">
                        <small>{{ tableZoom * 100 | number:'1.0-0' }}%</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row m-0 justify-content-between border-bottom">
                  <div class="col-12 py-2 text-center time-format-pref">
                    <small class="time-format-label">{{ 'time_format' | translate }}</small>
                    <div class="time-format-switch mt-1" role="group" aria-label="Time format">
                      <button
                        type="button"
                        class="time-format-chip"
                        [ngClass]="{'active': timeFormat == '24h'}"
                        (click)="setTimeFormat('24h')"
                      >
                        {{ 'time_format_24h' | translate }}
                      </button>
                      <button
                        type="button"
                        class="time-format-chip"
                        [ngClass]="{'active': timeFormat == '12h'}"
                        (click)="setTimeFormat('12h')"
                      >
                        {{ 'time_format_12h' | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="preferences-wrap"></div>
              <div class="divider"></div>
              <div class="dropdown-header"><strong>{{ 'session' | translate }}</strong></div>
              <a class="dropdown-item" style="cursor: pointer" (click)="logout()"><img class="custom-icon" src="/assets/icons/custom/logout_icon.svg" />{{ 'logout' | translate }}</a>
            </div>
          </li>
        </div>
      </div>
    </div>
    <div class="col-auto p-0 ml-1" *ngIf="showTitleBar">
      <div class="row m-0">
        <div (click)="titleAction('minimize')" class="btn-pwa-minimize">
          <i class="fa fa-window-minimize"></i>
        </div>
        <div (click)="titleAction('maximize')" class="btn-pwa-maximize">
          <i [class]="isWindowMaximized ? 'fa fa-clone' : 'fa fa-square-o'"></i>
        </div>
        <div (click)="titleAction('close')" class="btn-pwa-close">
          <i class="fa fa-close"></i>
        </div>
      </div>
    </div>
  </div>
</app-header>
</ng-container>
<div class="app-body">

  <ng-container *ngIf="!isShopPage() || isShopSidebarVisible">
    <app-sidebar #appSidebar [fixed]="true" [display]="'lg'" [minimized]="sidebarMinimized" (minimizedChange)="toggleMinimize($event)">
      <app-sidebar-minimizer class="sidebar-toggle-button"></app-sidebar-minimizer>
      <app-sidebar-nav [navItems]="navItems" [perfectScrollbar] (click)="onSidebarClick($event)"></app-sidebar-nav>
    </app-sidebar>
  </ng-container>
  
  <!-- Main content -->
  <main *ngIf="userData != null" class="main" [ngStyle]="{'margin-right': mainMarginRight}">
    <div *ngIf="!isUserVerified && licenseType == 'free'" class="warning-verified"><i class="fa fa-warning mr-1"></i>{{ licenseType == 'free' ? ('verify_account_free' | translate) : ('verify_account' | translate) }}. <a (click)="sendValidation()" class="send-verification-link">{{ 'send_another_email' | translate }}</a></div>
    <div class="warning-update" *ngIf="showUpdateIcon">
      <i class="fa fa-warning mr-3"></i>
      <b>{{ 'update_available' | translate }}</b>
      <span class="ml-2 mr-4">{{ 'update_text' | translate }}</span>
      <div (click)="installUpdate()" *ngIf="isUpdateReady" class="install-update-btn">{{ 'click_to_update' | translate }}<i class="ml-2 fa fa-download"></i></div>
      <i [tooltip]="updateDownloadProgress" *ngIf="!isUpdateReady && updateError.length == 0" class="fa fa-spinner spinner-anim"></i>
      <i [tooltip]="updateError" *ngIf="updateError.length > 0" class="fa fa-exclamation"></i>
    </div>
    <div class="warning-ggpoker" *ngIf="showGgpokerNotice()">
      <i class="fa fa-warning mr-2"></i>
      <b>{{ 'ggpoker_notice_title' | translate }}</b>
      <span class="ml-1">
        {{ 'ggpoker_notice_before_link' | translate }}
        <a
          [href]="ggpokerNoticeUrl"
          target="_blank"
          rel="noopener noreferrer"
          (click)="openExternal($event, ggpokerNoticeUrl)"
        >{{ 'ggpoker_notice_link' | translate }}</a>{{ 'ggpoker_notice_after_link' | translate }}
      </span>
    </div>
    <div class="offline-banner" *ngIf="false">
      <i class="fa fa-wifi mr-2"></i>{{ 'offline_banner_cache' | translate }}
    </div>
    <!-- Breadcrumb -->
    <!-- breaking change 'cui-breadcrumb' -->
    <!-- <cui-breadcrumb> -->
      <!-- Breadcrumb Menu-->
      <!-- <li class="breadcrumb-menu d-md-down-none">
        <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
          <a class="btn" href="#"><i class="icon-speech"></i></a>
          <a class="btn" [routerLink]="['/dashboard']"><i class="icon-graph"></i> &nbsp;Dashboard</a>
          <a class="btn" href="#"><i class="icon-settings"></i> &nbsp;Settings</a>
        </div>
      </li> -->
    <!-- </cui-breadcrumb> -->

    <!-- deprecation warning for 'app-breadcrumb' -->
    <!--<ol class="breadcrumb">-->
    <!--<app-breadcrumb></app-breadcrumb>-->
    <!--&lt;!&ndash; Breadcrumb Menu&ndash;&gt;-->
    <!--<li class="breadcrumb-menu d-md-down-none">-->
    <!--<div class="btn-group" role="group" aria-label="Button group with nested dropdown">-->
    <!--<a class="btn" href="#"><i class="icon-speech"></i></a>-->
    <!--<a class="btn" [routerLink]="['/dashboard']"><i class="icon-graph"></i> &nbsp;Dashboard</a>-->
    <!--<a class="btn" href="#"><i class="icon-settings"></i> &nbsp;Settings</a>-->
    <!--</div>-->
    <!--</li>-->
    <!--</ol>-->
    <div class="container-fluid h-100">
      <router-outlet></router-outlet>
    </div><!-- /.container-fluid -->
  </main>

<!--   <app-aside [fixed]="true" [display]="true" [ngClass]="'test'" [ngStyle]="{'margin-right': sideMarginRight}">
    <tabset>
      <tab (selectTab)="viewNotifications()">
        <ng-template tabHeading>
          <i class="icon-speech"></i>
          <span *ngIf="newNotifications.length > 0" class="badge badge-pill badge-danger position-absolute ml-n2 mt-n2">{{
            newNotifications.length }}</span>
        </ng-template>
        <div (click)="confirmDelete = undefined">
          <div *ngFor="let notification of notifications; let i = index; let last = last" class="message p-3">
            <div class="text-truncate font-weight-bold" [title]="notification.title">{{ notification.title }}</div>
            <div class="mt-n1"><small class="text-muted" [title]="formatDateFull(notification.date)">{{
                formatDate(notification.date) }}</small></div>
            <small class="text-muted">{{ notification.body }}</small>
            <div *ngIf="notification.actions && notification.actions.length > 0" class="mt-1">
              <button *ngFor="let action of notification.actions" class="btn btn-light border btn-sm mr-2" (click)="handleAction(notification, action.action)">{{ action.title }}</button>
            </div>
            <hr *ngIf="!last">
          </div>
          <div class="bg-secondary text-center px-4 py-2" *ngIf="notifications.length == 0">
            {{ 'no_notifications-atm' | translate }}
          </div>
        </div>
      </tab>
    </tabset>
  </app-aside> -->
  <!-- Snackbar -->
  <div id="snackbar" [ngClass]="{'show' : showSnackbar}">{{ snackbarMessage }}</div>
</div>
<ng-container *ngIf="!isShopPage()">
<app-footer>
  <span><a href="https://lobbyze.com">lobbyze</a> &copy; {{ currentYear }}</span>
  <div class="flex-grow-1">&nbsp;</div>
</app-footer>
</ng-container>
<!-- <Modal Add new tier> -->
  <div bsModal
  #addNewTierModal="bs-modal"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="Add new tier modal"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Create new tier</h4>
        <!-- TODO Translate this -->
        <button type="button" class="close" (click)="addNewTierModal.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <!-- Name-->
        <div class="form-group row">
          <div class="col-md-12">
            <div class="input-group" style="margin-top: 20px">
              <input autocomplete="false" type="text" class="form-control" placeholder="Schedule Name"
                [(ngModel)]="newTierName" />
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="addNewTierModal.hide()">
          {{ "cancel" | translate }}
        </button>
        <button type="button" class="btn btn-primary" [class.disabled]="isCreateNewTierInvalid"
          [disabled]="isCreateNewTierInvalid" (click)="addNewTierModal.hide(); createNewTier()">
          {{ "submit" | translate }}
        </button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- </Modal> -->

<!-- Modal Delete Tier-->
<div bsModal #modalDelete="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-danger" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ 'confirm_deletion' | translate }}</h4>
        <button type="button" class="close tour-close-delete" (click)="modalDelete.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h4 class="text-warning mb-4">{{ ('delete' | translate) + " " + tierToDelete.name }}?</h4>
        <h5 class="text-warning mb-4 pb-4">
          {{ 'confirm_deletion_tier_text' | translate }}
        </h5>
        <p>
          {{ 'confirm_deletion_tier_input' | translate }}
        </p>
        <input type="text" [(ngModel)]="confirmDeletionText" class="form-control" />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalDelete.hide()">
          {{ 'cancel' | translate }}
        </button>
        <button type="button" class="btn btn-danger" [disabled]="!isInputDeletionValid()" (click)="modalDelete.hide(); onClickDeleteTier()">
          {{ 'confirm' | translate }}
        </button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<!-- Modal Leave Tier-->
<div bsModal #modalLeave="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-danger" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">{{ 'confirm' | translate }}</h4>
        <button type="button" class="close tour-close-delete" (click)="modalLeave.hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h5 class="text-warning">{{ ('leave_tier' | translate) + " " + tierToDelete.name }}?</h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modalLeave.hide()">
          {{ 'cancel' | translate }}
        </button>
        <button type="button" class="btn btn-danger" (click)="modalLeave.hide(); leaveTier()">
          {{ 'confirm' | translate }}
        </button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->

<!-- Modal Notification Options -->
<ng-template #modalNotificationOptions>
  <div class="modal-header">
    <div class="modal-title">
      <h5>{{ 'notification_options' | translate }}</h5>
      <p class="mb-0">{{ 'notification_options_subtitle' | translate }}:</p>
    </div>
    <button type="button" class="close tour-close-delete" (click)="toggleModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div *ngIf="notificationOptions" class="modal-body px-0">
    <div class="row px-3 m-0 pb-4">
      <div class="col px-1">
        {{ 'enable_notifications' | translate }}
      </div>
      <div class="col-auto px-1">
        <label class="switch ml-2" (click)="notificationOptions.enabled = !notificationOptions.enabled; changeNotificationOptions()">
          <div class="switchCheck" [ngClass]="{'checked': notificationOptions.enabled}">
            <span class="slider round"></span>
            <span class="slider-text">{{ notificationOptions.enabled ? 'On' : 'Off' }}</span>
          </div>
        </label>
      </div>
    </div>
    <div *ngIf="notificationOptions.enabled" class="row m-0 border-bottom">
      <div class="col px-1">
        <div
          class="list-tab"
          [ngClass]="{ 'bg-primary': notificationOptionsTab == 'general' }"
          (click)="notificationOptionsTab = 'general'"
        >
          {{ "general" | translate }}
        </div>
      </div>
      <div class="col px-1">
        <div
          class="list-tab"
          [ngClass]="{ 'bg-primary': notificationOptionsTab == 'sound' }"
          (click)="notificationOptionsTab = 'sound'"
        >
          {{ "sound" | translate }}
        </div>
      </div>
      <div class="col px-1">
        <div
          class="list-tab"
          [ngClass]="{ 'bg-primary': notificationOptionsTab == 'grind' }"
          (click)="notificationOptionsTab = 'grind'"
        >
          {{ "grind_mode" | translate }}
        </div>
      </div>
    </div>
    <div *ngIf="notificationOptions.enabled && notificationOptionsTab == 'general'">
      <div class="row px-3 m-0 pb-4 border-bottom">
        <div class="col-12 px-1 pt-4 pb-3">
          {{ 'notification_options_text' | translate }}:
        </div>
        <div class="col-12 px-1">
          <div class="badge-list" cdkDropListGroup>
            <div cdkDropList [cdkDropListData]="i" *ngFor="let badge of badgeItems; let i = index;">
              <div cdkDrag class="badge-container" [cdkDragData]="i" (cdkDragEntered)="entered($event)" [ngClass]="{'disabled': !badge.enabled}">
                <div class="drag-handle" cdkDragHandle>
                  <svg width="12" height="12" viewBox="0 0 24 24">
                    <circle cx="8" cy="6" r="2" fill="currentColor"></circle>
                    <circle cx="16" cy="6" r="2" fill="currentColor"></circle>
                    <circle cx="8" cy="12" r="2" fill="currentColor"></circle>
                    <circle cx="16" cy="12" r="2" fill="currentColor"></circle>
                    <circle cx="8" cy="18" r="2" fill="currentColor"></circle>
                    <circle cx="16" cy="18" r="2" fill="currentColor"></circle>
                  </svg>
                </div>
                <div class="badge" [ngClass]="{'bg-dark': !badge.enabled, 'bg-primary': badge.enabled}" (click)="toggleBadge(badge)">
                  {{ ( badge.label | translate ) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row px-3 m-0 pt-4 pb-2 border-top">
        <div class="col-12 px-1 auto-close-grid">
          <div class="row m-0 align-items-center auto-close-grid-row">
            <div class="col-12 col-sm-4 col-lg-5 pl-0 pr-sm-2">
              <label>{{ 'hide_notifications_after' | translate }}:</label>
            </div>
            <div class="col-12 col-sm-4 col-lg-3 px-0 px-sm-1 mt-2 mt-sm-0">
              <input
                type="number"
                class="form-control"
                min="1"
                max="999"
                [(ngModel)]="notificationOptions.auto_close_after"
                (change)="changeNotificationOptions()"
              />
            </div>
            <div class="col-12 col-sm-4 col-lg-3 pl-0 pl-sm-2 mt-2 mt-sm-0">
              <span>{{ 'minutes' | translate }}</span>
            </div>
          </div>
        </div>
        <div class="col-12 px-1 mt-3">
          <div class="row m-0 align-items-center auto-close-grid-row">
            <div class="col-12 col-sm-4 col-lg-5 pl-0 pr-sm-2">
              <label>{{ 'notification_auto_close_after_end_of_register' | translate }}:</label>
            </div>
            <div class="col-12 col-sm-4 col-lg-3 px-0 px-sm-1 mt-2 mt-sm-0">
              <input
                type="number"
                class="form-control"
                min="0"
                max="999"
                [(ngModel)]="notificationOptions.auto_close_late_reg"
                (change)="changeNotificationOptions()"
              />
            </div>
            <div class="col-12 col-sm-4 col-lg-3 pl-0 pl-sm-2 mt-2 mt-sm-0">
              <span>{{ 'minutes' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="notificationOptions.enabled && notificationOptionsTab == 'sound'">
      <div class="row px-3 m-0 py-4">
        <div class="col px-1">
          {{ 'enable_sound' | translate }}
        </div>
        <div class="col-auto px-1">
          <label class="switch ml-2" (click)="notificationOptions.sound_enabled = !notificationOptions.sound_enabled; changeNotificationOptions()">
            <div class="switchCheck" [ngClass]="{'checked': notificationOptions.sound_enabled}">
              <span class="slider round"></span>
              <span class="slider-text">{{ notificationOptions.sound_enabled ? 'On' : 'Off' }}</span>
            </div>
          </label>
        </div>
      </div>
      <div *ngIf="notificationOptions.sound_enabled" class="row px-3 m-0">
        <div class="col-12 px-1 mb-3">
          <div class="row m-0 align-items-center">
            <div class="col-auto pl-1 pr-3">
              <label class="formCheckLabel" for="notificationSound">
                <input type="radio" class="formCheckInput mr-1" [checked]="notificationOptions.sound == 'default'" (click)="notificationOptions.sound = 'default'" (change)="changeNotificationOptions()" id="defaultSound" name="notificationSound">
                Sound 1
              </label>
            </div>
            <div class="col px-1">
              <app-audio-player [audioSrc]="'/assets/sounds/notification-sound.wav'" [volume]="notificationOptions.sound_volume" [speed]="notificationOptions.sound_speed"></app-audio-player>
            </div>
          </div>
        </div>
        <div class="col-12 px-1 mb-3">
          <div class="row m-0 align-items-center">
            <div class="col-auto pl-1 pr-3">
              <label class="formCheckLabel" for="notificationSound">
                <input type="radio" class="formCheckInput mr-1" [checked]="notificationOptions.sound == 'sound_2'" (click)="notificationOptions.sound = 'sound_2'" (change)="changeNotificationOptions()" id="sound2" name="notificationSound">
                Sound 2
              </label>
            </div>
            <div class="col px-1">
              <app-audio-player [audioSrc]="'/assets/sounds/notification-sound_2.mp3'" [volume]="notificationOptions.sound_volume" [speed]="notificationOptions.sound_speed"></app-audio-player>
            </div>
          </div>
        </div>
        <div class="col-12 px-1 mb-2">
          <div class="row m-0 align-items-center">
            <div class="col-auto pl-1 pr-3">
              <label class="formCheckLabel" for="notificationSound">
                <input type="radio" class="formCheckInput mr-1" [checked]="notificationOptions.sound == 'sound_3'" (click)="notificationOptions.sound = 'sound_3'" (change)="changeNotificationOptions()" id="sound3" name="notificationSound">
                Sound 3
              </label>
            </div>
            <div class="col px-1">
              <app-audio-player [audioSrc]="'/assets/sounds/notification-sound_3.wav'" [volume]="notificationOptions.sound_volume" [speed]="notificationOptions.sound_speed"></app-audio-player>
            </div>
          </div>
        </div>
        <div class="col-12 px-1 mt-3 mb-1">
          <div class="row m-0 align-items-center">
            <div class="col-12 px-1">
              {{ 'volume' | translate }}
            </div>
            <div class="col-auto px-1">
              <i class="fa fa-volume-off"></i>
            </div>
            <div class="col px-1">
              <div class="volume-slider">
                <ngx-slider [(value)]="notificationOptions.sound_volume" [options]="optionsNotificationVolume" (userChange)="changeNotificationOptions()"></ngx-slider>
              </div>
            </div>
            <div class="col-auto px-1">
              <i class="fa fa-volume-up"></i>
            </div>
          </div>
        </div>
        <div class="col-12 px-1 mt-3 mb-1">
          <div class="row m-0 align-items-center justify-content-between">
            <div class="col-12 px-1 mb-2">
              {{ 'speed' | translate }}
            </div>
            <div class="col-auto px-1">
              <label class="formCheckLabel" for="notificationSpeed">
                <input type="radio" class="formCheckInput mr-1" [checked]="notificationOptions.sound_speed == 0.25" (click)="notificationOptions.sound_speed = 0.25" (change)="changeNotificationOptions()" id="speed25" name="notificationSpeed">
                0.25x
              </label>
            </div>
            <div class="col-auto px-1">
              <label class="formCheckLabel" for="notificationSpeed">
                <input type="radio" class="formCheckInput mr-1" [checked]="notificationOptions.sound_speed == 0.5" (click)="notificationOptions.sound_speed = 0.5" (change)="changeNotificationOptions()" id="speed05" name="notificationSpeed">
                0.5x
              </label>
            </div>
            <div class="col-auto px-1">
              <label class="formCheckLabel" for="notificationSpeed">
                <input type="radio" class="formCheckInput mr-1" [checked]="notificationOptions.sound_speed == 1.0" (click)="notificationOptions.sound_speed = 1.0" (change)="changeNotificationOptions()" id="speed1" name="notificationSpeed">
                1x
              </label>
            </div>
            <div class="col-auto px-1">
              <label class="formCheckLabel" for="notificationSpeed">
                <input type="radio" class="formCheckInput mr-1" [checked]="notificationOptions.sound_speed == 1.5" (click)="notificationOptions.sound_speed = 1.5" (change)="changeNotificationOptions()" id="speed15" name="notificationSpeed">
                1.5x
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="notificationOptions.enabled && notificationOptionsTab == 'grind'">
      <div class="row px-3 pt-3 m-0">
        <div class="col-12 px-1">
          <label class="formCheckLabel" for="ignoreSkiped">
            <input type="checkbox" class="formCheckInput mr-1" id="ignoreSkiped" [(ngModel)]="notificationOptions.ignore_grind_skiped" (change)="changeNotificationOptions()">
            {{ 'ignore_notifications_skiped' | translate }}
          </label>
        </div>
        <div class="col-12 px-1">
          <label class="formCheckLabel" for="ignorePlaying">
            <input type="checkbox" class="formCheckInput mr-1" id="ignorePlaying" [(ngModel)]="notificationOptions.ignore_grind_playing" (change)="changeNotificationOptions()">
            {{ 'ignore_notifications_playing' | translate }}
          </label>
        </div>
        <div class="col-12 py-2 px-1">
          <small class="text-warning">{{ 'ignore_notifications_tip' | translate }}</small>
        </div>
        <div class="col-12 px-1 border-top pt-3">
          <label class="formCheckLabel" for="closeOnPlay">
            <input type="checkbox" class="formCheckInput mr-1" id="closeOnPlay" [(ngModel)]="notificationOptions.close_on_play" (change)="changeNotificationOptions()">
            {{ 'close_notification_on_play' | translate }}
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="toggleModal()">
      {{ 'close' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #modalStarterWizard>
  <div class="modal-header starter-wizard-header">
    <div class="modal-title mb-0">
      <h5 class="mb-0">{{ 'starter_wizard_title' | translate }}</h5>
      <small>{{ 'starter_wizard_subtitle' | translate }}</small>
    </div>
    <button type="button" class="close" (click)="closeStarterWizard()" aria-label="Close" [disabled]="starterWizardLoading">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body starter-wizard-body">
    <div class="starter-wizard-layout">
      <aside class="starter-wizard-aside">
        <div class="starter-robot-card">
          <div class="starter-wizard-bot">
            <span class="eye left"></span>
            <span class="eye right"></span>
            <span class="mouth"></span>
            <span class="antenna"></span>
            <img src="/assets/img/brand/logo2.png" class="antenna-logo pulse" alt="Lobbyze" />
          </div>
          <p class="starter-side-text">{{ 'starter_wizard_side_text' | translate }}</p>
          <div class="starter-wizard-progress" *ngIf="!starterWizardDone">{{ starterWizardStep + 1 }}/{{ starterWizardTotalSteps + 1 }}</div>
        </div>
      </aside>

      <section class="starter-wizard-content">
        <div *ngIf="starterWizardStep === 0 && !starterWizardDone" class="starter-step">
          <h4>{{ 'starter_wizard_welcome' | translate }}</h4>
          <p>{{ 'starter_wizard_welcome_text' | translate }}</p>
        </div>

        <div *ngIf="starterWizardStep === 1 && !starterWizardDone" class="starter-step">
          <h4>{{ 'starter_wizard_sites_question' | translate }}</h4>
          <p>{{ 'starter_wizard_sites_subtitle' | translate }}</p>
          <div class="starter-chip-grid">
            <button
              type="button"
              class="starter-chip"
              *ngFor="let site of starterWizardSiteOptions"
              [ngClass]="{ selected: starterWizardAnswers.siteIds.includes(site.id) }"
              (click)="toggleStarterSite(site.id)"
            >
              {{ site.name }}
            </button>
          </div>
        </div>

        <div *ngIf="starterWizardStep === 2 && !starterWizardDone" class="starter-step">
          <h4>{{ 'starter_wizard_buyin_question' | translate }}</h4>
          <p>{{ 'starter_wizard_buyin_subtitle' | translate }}</p>
          <div class="row">
            <div class="col-6">
              <label>{{ 'buy_in_min' | translate }}</label>
              <input type="number" min="0" class="form-control" [(ngModel)]="starterWizardAnswers.buyInMin" />
            </div>
            <div class="col-6">
              <label>{{ 'buy_in_max' | translate }}</label>
              <input type="number" min="0" class="form-control" [(ngModel)]="starterWizardAnswers.buyInMax" />
            </div>
          </div>
        </div>

        <div *ngIf="starterWizardStep === 3 && !starterWizardDone" class="starter-step">
          <h4>{{ 'starter_wizard_prize_question' | translate }}</h4>
          <p>{{ 'starter_wizard_prize_subtitle' | translate }}</p>
          <div class="row">
            <div class="col-6">
              <label>{{ 'prize_pool' | translate }} (min)</label>
              <input type="number" min="0" class="form-control" [(ngModel)]="starterWizardAnswers.prizePoolMin" />
            </div>
            <div class="col-6">
              <label>{{ 'prize_pool' | translate }} (max)</label>
              <input type="number" min="0" class="form-control" [(ngModel)]="starterWizardAnswers.prizePoolMax" />
            </div>
          </div>
        </div>

        <div *ngIf="starterWizardStep === 4 && !starterWizardDone" class="starter-step">
          <h4>{{ 'starter_wizard_style_question' | translate }}</h4>
          <p>{{ 'starter_wizard_style_subtitle' | translate }}</p>
          <label class="starter-label">{{ 'speed' | translate }}</label>
          <div class="starter-chip-grid mb-3">
            <button
              type="button"
              class="starter-chip"
              *ngFor="let speed of starterSpeedOptions"
              [ngClass]="{ selected: starterWizardAnswers.speeds.includes(speed) }"
              (click)="toggleStarterOption(speed, 'speeds')"
            >
              {{ speed }}
            </button>
          </div>
          <label class="starter-label">{{ 'type' | translate }}</label>
          <div class="starter-chip-grid mb-3">
            <button
              type="button"
              class="starter-chip"
              *ngFor="let type of starterTypeOptions"
              [ngClass]="{ selected: starterWizardAnswers.types.includes(type) }"
              (click)="toggleStarterOption(type, 'types')"
            >
              {{ type }}
            </button>
          </div>
          <label class="starter-label">{{ 'variant' | translate }}</label>
          <div class="starter-chip-grid mb-3">
            <button
              type="button"
              class="starter-chip"
              *ngFor="let variant of starterVariantOptions"
              [ngClass]="{ selected: starterWizardAnswers.variants.includes(variant) }"
              (click)="toggleStarterOption(variant, 'variants')"
            >
              {{ variant }}
            </button>
          </div>
          <label class="starter-label">{{ 'players' | translate }}</label>
          <div class="starter-chip-grid">
            <button
              type="button"
              class="starter-chip"
              *ngFor="let players of starterPlayersOptions"
              [ngClass]="{ selected: starterWizardAnswers.players.includes(players) }"
              (click)="toggleStarterOption(players, 'players')"
            >
              {{ players }}
            </button>
          </div>
        </div>

        <div *ngIf="starterWizardStep === 5 && !starterWizardDone" class="starter-step">
          <h4>{{ 'starter_wizard_days_question' | translate }}</h4>
          <p>{{ 'starter_wizard_days_subtitle' | translate }}</p>
          <div class="starter-chip-grid">
            <button
              type="button"
              class="starter-chip"
              *ngFor="let day of starterWeekDayOptions"
              [ngClass]="{ selected: starterWizardAnswers.weekDays.includes(day.id) }"
              (click)="toggleStarterWeekDay(day.id)"
            >
              {{ day.key | translate }}
            </button>
          </div>
        </div>

        <div *ngIf="starterWizardDone" class="starter-step starter-done">
          <h4>{{ 'starter_wizard_done_title' | translate }}</h4>
          <p>{{ 'starter_wizard_done_text' | translate }} <b>{{ starterWizardCreatedFilterName }}</b>.</p>
          <button type="button" class="btn btn-primary" (click)="goToScheduledTournamentsFromStarterWizard()">
            {{ 'starter_wizard_go_schedule' | translate }}
          </button>
        </div>
      </section>
    </div>
  </div>

  <div class="modal-footer" *ngIf="!starterWizardDone">
    <button type="button" class="btn btn-secondary" (click)="closeStarterWizard()" [disabled]="starterWizardLoading">{{ 'cancel' | translate }}</button>
    <button type="button" class="btn btn-outline-primary" *ngIf="starterWizardStep > 0" (click)="previousStarterStep()">{{ 'previous' | translate }}</button>
    <button type="button" class="btn btn-primary" *ngIf="starterWizardStep < starterWizardTotalSteps" [disabled]="!canGoToNextStarterStep()" (click)="nextStarterStep()">{{ 'next' | translate }}</button>
    <button type="button" class="btn btn-success" *ngIf="starterWizardStep === starterWizardTotalSteps" [disabled]="starterWizardLoading || !canGoToNextStarterStep()" (click)="completeStarterWizard()">
      <span *ngIf="!starterWizardLoading">{{ 'starter_wizard_create' | translate }}</span>
      <span *ngIf="starterWizardLoading"><i class="fa fa-spinner spinner-anim mr-1"></i>{{ 'loading' | translate }}</span>
    </button>
  </div>
</ng-template>
<!-- /.modal -->

<!-- Modal Preferences -->
<ng-template #modalPreferences>
  <div class="modal-header">
    <div class="modal-title">
      <h5>{{ 'window_behavior' | translate }}</h5>
      <p class="mb-0">{{ 'preferences_subtitle' | translate }}</p>
    </div>
    <button type="button" class="close" (click)="toggleModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body px-0">
    <div *ngIf="isNativeMode()" class="row px-3 m-0 py-4">
      <div class="col-12 px-1 mb-3">
        <h6>{{ 'close_window_behavior' | translate }}</h6>
      </div>
      <div class="col-12 px-1">
        <div class="row m-0">
          <div class="col-12 px-1 mb-3">
            <label class="formCheckLabel" for="closeBehaviorTrayPrefs">
              <input 
                type="radio" 
                class="formCheckInput mr-2" 
                id="closeBehaviorTrayPrefs" 
                name="closeWindowBehaviorPrefs"
                [value]="'tray'"
                [(ngModel)]="closeWindowBehavior" 
                (change)="changeCloseWindowBehavior()"
              />
              {{ 'hide_to_tray' | translate }}
            </label>
            <div class="ml-4 pl-2">
              <small class="text-muted">{{ 'hide_to_tray_description' | translate }}</small>
            </div>
          </div>
          <div class="col-12 px-1">
            <label class="formCheckLabel" for="closeBehaviorClosePrefs">
              <input 
                type="radio" 
                class="formCheckInput mr-2" 
                id="closeBehaviorClosePrefs" 
                name="closeWindowBehaviorPrefs"
                [value]="'close'"
                [(ngModel)]="closeWindowBehavior" 
                (change)="changeCloseWindowBehavior()"
              />
              {{ 'close_completely' | translate }}
            </label>
            <div class="ml-4 pl-2">
              <small class="text-muted">{{ 'close_completely_description' | translate }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="toggleModal()">
      {{ 'close' | translate }}
    </button>
  </div>
</ng-template>
<!-- /.modal -->

<ng-template #editNotificationModal *ngIf=" updateNotificationConfig$ | withMultiLoading | async as config">
  <ng-container *ngIf="config.value as value; else err">
    <div class="modal-header bg-primary">
      <h5 class="modal-title pull-left">
        {{ editingScheduleName }}
      </h5>
      <button type="button" class="close pull-right" aria-label="Close" (click)="toggleModal()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body p-0">
      <div class="form-group edit-grid px-3 py-2">
        <h4>{{ 'notification' | translate }}</h4>
        <ng-container *ngFor="let not of value.data.notifications">
          <div class="d-flex py-1" *ngIf="showNotification(value.id_list, not.schedules)">
            <div class="input-group">
              <div *ngIf="not.notification_type != 'at' && not.notification_type != 'at-blind'" class="input-group-append">
                <div class="input-group-text w-text">{{ 'minutes_capital' | translate }}</div>
              </div>
              <input *ngIf="not.notification_type != 'none' && not.notification_type != 'when-start' && not.notification_type != 'at' && not.notification_type != 'at-blind'" type="number" min="0" class="form-control" name="notificationConfig.notification" (keyup)="(not.notification == 0 ? not.notification = 1 : null); setNotificationAsRegisterTime(value.data.notifications)" [(ngModel)]="not.notification" placeholder="Unchanged">
              <input *ngIf="showTimeSelect || not.notification_type == 'at'" [(ngModel)]="not.notification" type="time" class="form-control" style="max-width: 150px; min-width: 150px;" (keyup)="setNotificationAsRegisterTime(value.data.notifications)">
              <button class="btn btn-secondary btn-blind" *ngIf="not.notification_type == 'at-blind'" (click)="openStructureSelect(not, value.data.notifications)">
                {{ 'select' | translate }}
              </button>
              <input *ngIf="not.notification_type == 'at-blind'" type="text" class="form-control" [(ngModel)]="not.notification" (keyup)="setNotificationAsRegisterTime(value.data.notifications)">
              <select class="form-control" id="notification-select" [(ngModel)]="not.notification_type" placeholder="Unchanged" (change)="($event.target.selectedIndex > 1 && $event.target.selectedIndex < 5 ? not.notification = 1 : not.notification = 0); setNotificationAsRegisterTime(value.data.notifications)">
                <option value="none">{{ 'no_notification' | translate }}</option>
                <option value="when-start">{{ 'when_start' | translate }}</option>
                <option value="before-start">{{ 'before_start' | translate }}</option>
                <option value="after-start">{{ 'after_start' | translate }}</option>
                <option value="before-register">{{ 'before_register' | translate }}</option>
                <option value="at">{{ 'set_time' | translate }}</option>
                <option value="at-blind">{{ 'number_blinds' | translate }}</option>
              </select>
            </div>
          </div>
        </ng-container>
        <div class="mb-3">
          <div class="row justify-content-between">
            <div class="col-auto">
              <button class="btn btn-sm btn-success" (click)="addNotification(value.data.notifications, value.id_list)"><i class="fa fa-plus mr-1"></i>{{ 'add_notification' | translate }}</button>
            </div>
            <div class="col-auto">
              <button class="btn btn-sm btn-danger" (click)="clearNotifications(value.data.notifications)" *ngIf="hasNotifications(value.data.notifications, value.id_list)"><i class="fa fa-trash mr-1"></i>{{ 'clear_notifications' | translate }}</button>
            </div>
          </div>
        </div>
        <div class="d-flex py-1">
          <input type="checkbox" [(ngModel)]="replicateNotification" class="mr-1">{{'reflect_notificaion_all_days_week' | translate}}
        </div>
        <div class="d-flex py-1">
          <input type="checkbox" [(ngModel)]="setRegTimeFromNotification" (change)="setNotificationAsRegisterTime(value.data.notifications)" class="mr-1">{{'set_reg_time_from_notification' | translate}}
        </div>
        <div *ngIf="setRegTimeFromNotification && notificationTimeChanged" class="alert alert-warning py-2 mt-2 mb-0">
          <small>{{ 'notification_time_adjusted_interval_warning' | translate }}</small>
        </div>
      </div>
      <div class="form-group edit-grid bg-extra mb-0 px-3 py-2 border-top">
        <h4>{{ 'extra_options' | translate }}</h4>
        <div class="d-flex py-1" *ngIf="isMaster">
          <div class="input-group">
            <div class="input-group-prepend">
              <label class="input-group-text w-text">{{ 'priority' | translate }}</label>
            </div>
            <select *ngIf="value.data.priority < 1000" [(ngModel)]="value.data.priority" class="custom-select text-capitalize">
              <option value="1">1 - {{ 'VERY_LOW' | translate }}</option>
              <option value="2">2 - {{ 'VERY_LOW' | translate }}</option>
              <option value="3">3 - {{ 'LOW' | translate }}</option>
              <option value="4">4 - {{ 'LOW' | translate }}</option>
              <option value="5">5 - {{ 'MEDIUM' | translate }}</option>
              <option value="6">6 - {{ 'MEDIUM' | translate }}</option>
              <option value="7">7 - {{ 'MEDIUM' | translate }}</option>
              <option value="8">8 - {{ 'HIGH' | translate }}</option>
              <option value="9">9 - {{ 'HIGH' | translate }}</option>
              <option value="10">10 - {{ 'HIGH' | translate }}</option>
            </select>
            <select *ngIf="value.data.priority >= 1000" [(ngModel)]="value.data.priority" (change)="removeAutoPriority(value.data)" class="custom-select text-capitalize">
              <option value="1001">1 - {{ 'VERY_LOW' | translate }}</option>
              <option value="1002">2 - {{ 'VERY_LOW' | translate }} </option>
              <option value="1003">3 - {{ 'LOW' | translate }} </option>
              <option value="1004">4 - {{ 'LOW' | translate }} </option>
              <option value="1005">5 - {{ 'MEDIUM' | translate }} </option>
              <option value="1006">6 - {{ 'MEDIUM' | translate }} </option>
              <option value="1007">7 - {{ 'MEDIUM' | translate }} </option>
              <option value="1008">8 - {{ 'HIGH' | translate }} </option>
              <option value="1009">9 - {{ 'HIGH' | translate }} </option>
              <option value="1010">10 - {{ 'HIGH' | translate }} </option>
            </select>
          </div>
        </div>
        <div class="d-flex py-1">
          <input type="checkbox" [(ngModel)]="replicatePriority" class="mr-1">
          {{'reflect_priority_all_days_week' | translate}}
        </div>
      </div>
      <div class="form-group mb-0 bg-extra pt-2 px-3 pb-3">
        <div class="d-flex py-1">
          <div class="input-group">
            <div class="input-group-prepend">
              <label class="input-group-text w-text">{{ 'comment' | translate }}</label>
            </div>
            <input type="text" class="form-control" [(ngModel)]="schComment" [placeholder]="schComment == null ? 'Unchanged' : ''">
          </div>
        </div>
        <div class="d-flex py-1">
          <input type="checkbox" [(ngModel)]="commentReflectAll" class="mr-1">
          {{'reflect_comment_all_days_week' | translate}}
        </div>
      </div>
      <div class="form-group mb-0 bg-extra pt-2 px-3 pb-4">
        <div class="d-flex py-1">
          <div class="input-group">
            <div class="input-group-prepend">
              <label class="input-group-text">{{ 'registration_time' | translate }}</label>
            </div>
            <input [(ngModel)]="registerTime" type="time" class="form-control">
          </div>
        </div>
        <div class="d-flex pt-1">
          <input type="checkbox" [(ngModel)]="registerReflectAll" class="mr-1">{{'reflect_register_all_days_week' | translate}}
        </div>
        <div class="d-flex">
          <input type="checkbox" [(ngModel)]="registerSetNotification" (change)="setRegisterAsNotification(value.data.notifications, value.id_list)" class="mr-1">{{'set_notification' | translate}}
        </div>
      </div>
      <div *ngIf="isMaster" class="form-group mb-0 bg-extra pt-1 px-3 pb-4">
        <div class="d-flex pb-1">
          <div class="input-group">
            <div class="input-group-prepend">
              <label class="input-group-text w-text">{{ 'max_rebuy' | translate }}</label>
            </div>
            <input [(ngModel)]="maxRebuy" (keyup)="checkValidRebuy()" type="text" class="form-control">
          </div>
        </div>
        <div class="d-flex pt-1">
            <input type="checkbox" [(ngModel)]="maxRebuyReflectAll" class="mr-1">{{'reflect_rebuy_all_days_week' | translate}}
        </div>
      </div>
    </div>
    <div class="modal-footer" style="display: block;">
      <div class="row justify-content-between">
        <div class="col">
        </div>
        <div class="col">
          <button type="button" class="btn btn-success mx-1 float-right" (click)="onClickUpdateSchedule(value)"
            type="submit">
            <i class="fa fa-save mr-1"></i>{{ 'save' | translate }}
          </button>
          <button type="button" class="btn btn-secondary mx-1 float-right" data-dismiss="modal" (click)="toggleModal()">
            {{ 'cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-template #err>
    <div class="modal-header">
      <h4 class="modal-title pull-left">
        {{ config.error ? ' Error' : 'Loading' }}
      </h4>
    </div>
    <div class="modal-body">
      <div class="flex flex-column justify-content-center align-items-center">
        <span class="dropdown-item no-click" *ngIf="config.loading"><i class="fa fa-arrow-circle-o-down"></i>{{ 'loading' | translate }}...</span>
        <ng-container *ngIf="config.error">
          <span class="dropdown-item no-click"><i class="fa fa-exclamation"></i>Error</span>
          <span class="dropdown-item no-click">{{ (config.error.error || config.error) | json }}</span>
        </ng-container>
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #modalBlinds>
  <div class="modal-header bg-primary">
    <h4 class="modal-title">{{ 'select_blind' | translate }}</h4>
    <button type="button" class="close" (click)="toggleModalStructure()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body p-0">
    <ng-container *ngIf="structures && structures.length > 0; else emptyStructure">
      <div class="px-2">
        <div class="py-1" style="max-height: 327px; overflow: auto">
          <table class="table table-hover table-borderless table-striped" style="width: calc(100% - 4px)">
            <thead>
              <tr class="table-header">
                <th></th>
                <th>{{ "level" | translate }}</th>
                <th>{{ "blinds" | translate }}</th>
                <th>{{ "big_blind_stack" | translate }}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr class="ngt-row-torneo" *ngFor="let level of selectedStructure?.data?.levels; let i = index" [ngClass]="{'current-level': isCurrentLevel(level.init_blind, selectedStructure.schedule_id)}">
                <td>
                  <span *ngIf="isCurrentLevel(level.init_blind, selectedStructure.schedule_id)" class="badge badge-success">{{ 'current' | translate }}</span>
                </td>
                <td>{{ i + 1 }}</td>
                <td>{{ level.blinds / 2 }} / {{ level.blinds }}</td>
                <td>{{ level.init_blind }}</td>
                <td>
                  <button class="btn btn-success" (click)="selectBlind(level.init_blind)">{{ 'select' | translate }}</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>
    <ng-template #emptyStructure>
      <div class="py-4 text-center">
        ...loading
      </div>
    </ng-template>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="toggleModalStructure()">
      {{ 'close' | translate }}
    </button>
  </div>
</ng-template>

<!-- Modal Welcome Page -->
<main-guide></main-guide>